export default __webpack_public_path__ + "static/Atem-0e719d4284fb7a82b253bc18fdc85dd0.png";